export function formatEventTime(timestamp) {
  if (!timestamp) return "";

  try {
    return new Date(timestamp).toLocaleTimeString("en-AU", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return "";
  }
}

export function formatDispatchEvent(event) {
  const type = event?.type || "event";
  const channel = event?.channel || "";

  // Hide noisy internal telemetry
  if (
    type === "pong" ||
    type === "dashboard_update" ||
    type === "location_update"
  ) {
    return null;
  }

  if (type === "presence_update") {
    const role = String(event.role || "User").replaceAll("_", " ");
    const status = event.status || "updated";

    return {
      title: `${role} is ${status}`,
      subtitle: `User ${event.user_id || "unknown"}`,
      severity: status === "online" ? "success" : "neutral",
      category: "Presence",
      time: formatEventTime(event.timestamp),
    };
  }

  if (type === "connected") {
    return {
      title: "Realtime connection established",
      subtitle: "Live Operations is connected",
      severity: "success",
      category: "System",
      time: formatEventTime(event.timestamp),
    };
  }

  if (type === "pong") {
    return {
      title: "Heartbeat confirmed",
      subtitle: "Realtime connection healthy",
      severity: "neutral",
      category: "System",
      time: formatEventTime(event.timestamp),
    };
  }

  if (type === "dispatch_event") {
    return {
      title: event.message || "Dispatch Event",
      subtitle: event.category || "Operations",
      severity: event.severity || "neutral",
      category: "Dispatch",
      time: formatEventTime(event.timestamp),
    };
  }

  return {
    title: type.replaceAll("_", " "),
    subtitle: channel || "Live Operations",
    severity: "neutral",
    category: "Event",
    time: formatEventTime(event.timestamp),
  };
}

export function severityClass(severity) {
  switch (severity) {
    case "success":
      return "border-emerald-500/30 bg-emerald-500/10 text-emerald-300";
    case "warning":
      return "border-yellow-500/30 bg-yellow-500/10 text-yellow-300";
    case "critical":
      return "border-red-500/30 bg-red-500/10 text-red-300";
    default:
      return "border-zinc-800 bg-zinc-950 text-zinc-300";
  }
}
